import { render } from "./FiltterView.vue?vue&type=template&id=2ced8bc4&scoped=true"
import script from "./FiltterView.vue?vue&type=script&lang=js"
export * from "./FiltterView.vue?vue&type=script&lang=js"

import "./FiltterView.vue?vue&type=style&index=0&id=2ced8bc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ced8bc4"]])

export default __exports__